import TweetList from './TweetList.js';
var React = require('react');
const createReactClass = require("create-react-class");

//TwitterStream Displays A List of All Twitter Messages as Cards
//Uses TweetList.js
var TwitterStream = createReactClass({

    render: function () {
        //Pass collectedTweets to TweetList
        return (
            <div className="stream col-sm-4">
                <h1>Twitter Stream</h1>
                <TweetList collectedTweets={this.props.collectedTweets}/>
            </div>
        );
    }
});

export default TwitterStream;